import { LmIconFilledMiscSchool } from '@mes-ui/lemma/icons';

const IconSchoolFilled = (props: React.SVGProps<SVGSVGElement>) => <LmIconFilledMiscSchool {...props} />;

export default IconSchoolFilled;
